import React, { useEffect, useState, useRef } from "react";
import {
  Container,
  Grid,
  Paper,
  Typography,
  Avatar,
  CircularProgress,
  Backdrop,
  Input,
  InputLabel,
  FormControl,
  InputAdornment,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import "./StudentProfileComponents/StudentProfile.css";
import TabsComponent from "./StudentProfileComponents/Tabs.js";
import CourseDetails from "./StudentProfileComponents/CourseDetails.js";
import ContentWrapper from "../common/ContentWrapper.js";
import { StudentService } from "../../service/manage/registration/student.service.js";
import { useLocation } from "react-router-dom/cjs/react-router-dom.js";
import { Spinner } from "react-bootstrap";
import { cgcUploadTypes } from "../../helper/namespace.js";
import { AzureStorageManage } from "../../helper/azureStorageManage.js";
import { routes } from "../../helper/routes.js";
import Button from "react-bootstrap/Button";
import { history } from "../../helper/history.js";
import Lottie from "react-lottie";
import barcodeAnimation from "./asserts/BarCode_scan_animation.json";
import scanned_animation from "./asserts/scanned.json";
import CryptoJs from "crypto-js";
import { sweetStatusAlert } from "../common/SweetAlert.js";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "20px",
  },
}));

function StudentProfile() {
  const classes = useStyles();
  const [studentDetail, setStudentDetails] = useState(null);
  const [propStateStudent, setPropStateStudent] = useState(null);
  const [courseDetail, setCourseDetail] = useState([]);
  const [paymentDetail, setPaymentDetail] = useState([]);
  const [marksDetail, setMarksDetail] = useState([]);
  const [uploads, setUploads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [profileUrl, setProfileUrl] = useState(undefined);
  const [barcodeValue, setBarcodeValue] = useState("");
  const [barcodeState, setBarcodeState] = useState("pending");
  const [loginUserId, setLoginUserId] = useState(
    sessionStorage.getItem("manage_user_id")
  );
  const [loginUserTableId, setLoginUserTableId] = useState(
    sessionStorage.getItem("table_log_id")
  );
  const [sessionNodeID, setSessionNodeID] = useState(
    sessionStorage.getItem("root_node_id")
  );

  const location = useLocation();
  const inputRef = useRef(null);
  const debounceTimerRef = useRef(null);

  const fetchAllFormDetails = async (user_id, user_table_id) => {
    try {
      setLoading(true);
      const resStudentDetail = await StudentService.getCgcStudentAllDetail(
        user_id,
        user_table_id,
        loginUserId,
        loginUserTableId,
        sessionNodeID
      );

      if (resStudentDetail) {
        setLoading(false);
        setStudentDetails(resStudentDetail);
        const handleCourseDetial = resStudentDetail?.data.find(
          (form) => form.form_list_id === 6
        );
        const handleMarksDetail = resStudentDetail?.data.find(
          (form) => form.form_list_id === 17
        );
        const handlePaymentsDetail = resStudentDetail?.data.find(
          (form) => form.form_list_id === 28
        );
        const handleUploadDetail = resStudentDetail?.data.find(
          (form) => form.form_list_id === 32
        );
        handleCourseDetial && setCourseDetail(handleCourseDetial?.detail);
        handleMarksDetail && setMarksDetail(handleMarksDetail?.detail);
        handlePaymentsDetail && setPaymentDetail(handlePaymentsDetail?.detail);
        handleUploadDetail && setUploads(handleUploadDetail?.detail);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (location?.state?.student) {
      if (location?.state?.student === "bar_code") {
        inputRef.current.focus();
        setBarcodeState("pending");
      } else {
        setPropStateStudent(location.state.student);
        const { user_id, user_table_id } = location.state.student;
        fetchAllFormDetails(user_id, user_table_id);
      }
    }
  }, [location?.state?.student]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleBarcodeInput = async (event) => {
    const scannedBarcode = event.target.value;
    setBarcodeValue(scannedBarcode);

    clearTimeout(debounceTimerRef.current);
    debounceTimerRef.current = setTimeout(async () => {
      setPropStateStudent(null);
      setBarcodeState("scanned");
      await fetchProfileDetails(scannedBarcode);
    }, 300);
  };

  const fetchProfileDetails = async (user_code) => {
    const response = await StudentService.getStudentProfileAndTableIds(
      user_code
    );
    if (response.success) {
      setPropStateStudent(response?.data?.student_details_list[0]);
      setBarcodeState("done");
      setBarcodeValue("");
      inputRef.current.focus();
      await fetchAllFormDetails(
        response?.data?.studentsIds[0]?.user_id,
        response?.data?.studentsIds[0]?.table_id
      );
    } else {
      sweetStatusAlert(
        "Failed",
        typeof response.message === "string" ? response.message : "Invalid code"
      );
      setBarcodeState("pending");
      setBarcodeValue("");
      inputRef.current.focus();
    }
  };

  const handleSwitchScanPage = () => {
    setBarcodeState("pending");
    inputRef.current.focus();
    setPropStateStudent(null);
    setBarcodeValue("");
  };

  const handleStudents = () => {
    const fromPath = location?.state?.from?.pathname || routes.manage_student;
    // const fromSearch = location?.state?.from?.search || '';

    history.push({
      pathname: fromPath,
      state: {
        ...location.state,
      },
    });
  };

  const fetchBlobSasUrl = async (uploads = []) => {
    const photoBlobs = [];
    const checkPhotoFormat = (blob_id) => {
      const splitted = blob_id.split(".");
      const format = splitted[splitted.length - 1].toLowerCase();
      const checkPhotoFormat =
        format === "jpg" || format === "png" || format === "jpeg";
      return checkPhotoFormat;
    };
    uploads.forEach((element) => {
      if (
        element.upload_type_id === cgcUploadTypes.CGC_PHOTO_UPLOADS.id &&
        checkPhotoFormat(element.blob_id)
      ) {
        photoBlobs.push(element);
      }
    });
    if (!!photoBlobs?.length) {
      try {
        const profUrl = await AzureStorageManage.generateSASUrl(
          photoBlobs[0].container_id,
          photoBlobs[0].blob_id
        );
        setProfileUrl(profUrl);
        return profUrl;
      } catch (error) {
        return undefined;
      }
    }
    return undefined;
  };

  useEffect(() => {
    fetchBlobSasUrl(uploads);
  }, [uploads]);

  const barcodeAnimationOptions = {
    loop: true,
    autoplay: true,
    animationData: barcodeAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const scannedAnimationOptions = {
    loop: true,
    autoplay: true,
    animationData: scanned_animation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <ContentWrapper disabled={true}>
      <Container className="root" style={{ minHeight: "90vh" }}>
        <Grid container spacing={3}>
          {location?.state?.student === "bar_code" &&
          barcodeState === "pending" ? (
            <Grid item xs={12}>
              <div className="barcode-scanner-section">
                <Typography variant="h6">
                  Waiting for Barcode Scan...
                </Typography>
                <FormControl fullWidth sx={{ m: 1 }} variant="standard">
                  <TextField
                    fullWidth
                    label="Barcode Value"
                    id="fullWidth"
                    type="text"
                    inputRef={inputRef}
                    autoFocus
                    value={barcodeValue}
                    onChange={handleBarcodeInput}
                  />
                </FormControl>
                <Lottie
                  options={barcodeAnimationOptions}
                  height={500}
                  width={500}
                />

                {/* Hidden input for barcode scanner */}
                {/* <input
                  type="text"
                  ref={inputRef}
                  // style={{ position: 'absolute', opacity: 0 }}
                  value={barcodeValue}
                  onChange={handleBarcodeInput}
                /> */}
              </div>
            </Grid>
          ) : location?.state?.student === "bar_code" &&
            barcodeState === "scanned" ? (
            <Grid item xs={12}>
              <div className="barcode-scanner-section">
                <Typography variant="h6">Fetching Data...</Typography>
                <FormControl fullWidth sx={{ m: 1 }} variant="standard">
                  <TextField
                    fullWidth
                    label="Barcode Value"
                    id="fullWidth"
                    type="text"
                    inputRef={inputRef}
                    disabled
                    value={barcodeValue}
                  />
                </FormControl>
                <Lottie
                  options={scannedAnimationOptions}
                  height={500}
                  width={500}
                />
              </div>
            </Grid>
          ) : (
            <>
              {location?.state?.student === "bar_code" &&
                barcodeState === "done" && (
                  <Grid item xs={12}>
                    <div className="barcode-scanner-section">
                      <Typography variant="h6">Scan Barcode...</Typography>
                      <FormControl fullWidth sx={{ m: 1 }} variant="standard">
                        <TextField
                          fullWidth
                          label="Barcode Value"
                          id="fullWidth"
                          type="text"
                          inputRef={inputRef}
                          autoFocus
                          value={barcodeValue}
                          onChange={handleBarcodeInput}
                        />
                      </FormControl>
                    </div>
                  </Grid>
                )}
              {/* Profile Header */}
              <Grid item xs={12}>
                <div className="profileHeader row">
                  <div className="row d-flex align-items-center">
                    <img
                      className="avatar"
                      src={
                        !!profileUrl
                          ? profileUrl
                          : "https://via.placeholder.com/100"
                      }
                      alt="Profile-Icon"
                    />
                    <div>
                      <Typography className="name" variant="h5">
                        <strong>{`${propStateStudent?.first_name} ${propStateStudent?.last_name}`}</strong>
                      </Typography>
                      <Typography variant="body2">
                        Student ID: {propStateStudent?.user_code}
                      </Typography>
                    </div>
                  </div>
                  <div className="aprstat">
                    <p>Document Approved Status: </p>&emsp;
                    <p
                      className={`${
                        propStateStudent?.status === 1
                          ? "clrCompleted status"
                          : "clrPending status"
                      }`}
                    >
                      {propStateStudent?.status === 1 ? "Approved" : "Pending"}
                    </p>
                  </div>
                  {/* <div className='aprstat'>
                      <p>Document Approved Status: </p>&emsp;<p className={`${propStateStudent?.status === 1 ? 'statz clr1' : 'statz clr2'}`}>
                        {propStateStudent?.status === 1
                          ? "Approved"
                          : "Pending"}&nbsp;<p className={`${propStateStudent?.status === 1 ? 'dot' : 'dot2'}`}>⦿</p></p>
                    </div> */}
                  <div>
                    {<Button onClick={() => handleStudents()}>Back</Button>}
                  </div>
                  {location?.state?.student === "bar_code" && (
                    <div>
                      {
                        <Button onClick={() => handleSwitchScanPage()}>
                          Close Profile
                        </Button>
                      }
                    </div>
                  )}
                </div>
              </Grid>

              {/* Profile Details */}
              <Grid item xs={12} md={5}>
                <div className="profileDetails">
                  <Typography
                    className="col-md-12 px-0 profdata"
                    variant="body1"
                  >
                    <div className="col-md-5 px-0 profdata2 profdata3">NIC</div>
                    <div className="col-md-7 px-0 profdata2">
                      :&emsp;{propStateStudent?.nic}
                    </div>
                  </Typography>
                  <Typography
                    className="col-md-12 px-0 profdata"
                    variant="body1"
                  >
                    <div className="col-md-5 px-0 profdata2 profdata3">
                      Gender
                    </div>
                    <div className="col-md-7 px-0 profdata2">
                      :&emsp;{propStateStudent?.gender}
                    </div>
                  </Typography>
                  <Typography
                    className="col-md-12 px-0 profdata"
                    variant="body1"
                  >
                    <div className="col-md-5 px-0 profdata2 profdata3">DOB</div>
                    <div className="col-md-7 px-0 profdata2">
                      :&emsp;{propStateStudent?.dob}
                    </div>
                  </Typography>
                  <Typography
                    className="col-md-12 px-0 profdata"
                    variant="body1"
                  >
                    <div className="col-md-5 px-0 profdata2 profdata3">
                      Contact Number (Mobile)
                    </div>
                    <div className="col-md-7 px-0 profdata2">
                      :&emsp;{propStateStudent?.mobile}
                    </div>
                  </Typography>
                  <Typography
                    className="col-md-12 px-0 profdata"
                    variant="body1"
                  >
                    <div className="col-md-5 px-0 profdata2 profdata3">
                      Contact Number (Home)
                    </div>
                    <div className="col-md-7 px-0 profdata2">
                      :&emsp;{propStateStudent?.home}
                    </div>
                  </Typography>
                  <Typography
                    className="col-md-12 px-0 profdata"
                    variant="body1"
                  >
                    <div className="col-md-5 px-0 profdata2 profdata3">
                      Email
                    </div>
                    <div className="col-md-7 px-0 profdata2">
                      :&emsp;{propStateStudent?.email}
                    </div>
                  </Typography>
                  <Typography
                    className="col-md-12 px-0 profdata"
                    variant="body1"
                  >
                    <div className="col-md-5 px-0 profdata2 profdata3">
                      Address for Correspondence
                    </div>
                    <div className="col-md-7 px-0 profdata2">
                      :&emsp;{propStateStudent?.address_for_correspondence}
                    </div>
                  </Typography>
                  <Typography
                    className="col-md-12 px-0 profdata"
                    variant="body1"
                  >
                    <div className="col-md-5 px-0 profdata2 profdata3">
                      Permanent Address
                    </div>
                    <div className="col-md-7 px-0 profdata2">
                      :&emsp;{propStateStudent?.permanent_address}
                    </div>
                  </Typography>
                </div>
              </Grid>

              {/* Course Details */}
              <Grid item xs={12} md={7}>
                <div>
                  <Paper className="courseDetails">
                    <Typography variant="h6">
                      <strong>Course Details</strong>
                    </Typography>
                    {loading ? (
                      <div className="loading-container mb-5 mt-10">
                        <Spinner
                          animation="border"
                          role="status"
                          style={{ display: "block", margin: "auto" }}
                        >
                          <span className="sr-only">Loading...</span>
                        </Spinner>
                      </div>
                    ) : (
                      <div className="theCourses">
                        <CourseDetails
                          courseDetail={courseDetail}
                          loading={loading}
                        />
                      </div>
                    )}
                  </Paper>
                </div>
              </Grid>

              {/* Tabs for Payments, Documents, Mark Sheet */}
              <Grid item xs={12}>
                {loading ? (
                  <div className="loading-container mb-5 mt-10">
                    <Spinner
                      animation="border"
                      role="status"
                      style={{ display: "block", margin: "auto" }}
                    >
                      <span className="sr-only">Loading...</span>
                    </Spinner>
                  </div>
                ) : (
                  <TabsComponent
                    paymentForms={paymentDetail}
                    marksForms={marksDetail}
                    uploads={uploads}
                    loading={loading}
                  />
                )}
              </Grid>
            </>
          )}
        </Grid>
      </Container>
    </ContentWrapper>
  );
}

export default StudentProfile;
